var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuProducts'),_c('Product_Close')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }